/**
 * Prize amounts live in the database as cents ("500000"). The old app showed
 * them with a comma before the last two digits and sent them back with the
 * comma stripped (`Format.currencyInput`, `drawingbase_obj.js`), so the same
 * shape is kept here.
 */
export const EMPTY_AMOUNT = '0,00';

export const centsToAmountInput = (cents: string | number): string => {
  const digits = String(cents ?? '').replace(/\D/g, '') || '0';
  const padded = digits.padStart(3, '0');
  return `${padded.slice(0, -2)},${padded.slice(-2)}`;
};

export const amountInputToCents = (input: string): string => input.replace(',', '');

/** Euros with exactly two decimals, as the old form demanded. */
export const isValidAmountInput = (input: string): boolean => /^(0|[1-9][0-9]*),[0-9]{2}$/.test(input);
